
      import Hot from './hot.vue'
      import type { App, Plugin } from 'vue'

      export const HotPlugin: Plugin = {
        install(app: App) {
          app.component('Hot', Hot)
        },
      }
      export { Hot }
      